// Outreach statuses that mean the contact answered (shared by src/utils.jsx and src/outreachEvidence.js).
export const REPLY_STATUS_NAMES = new Set(['Replied', 'Received', 'Meeting Booked', 'Meeting Confirmed', 'Interested', 'Positive Reply']);
